<!-- 
  we need empty string while logedin 
  we need 'without-login' while user is not loged in


  i have set this "userLogedIn" false in Ts file please loo that as well

-->
<section [ngClass]="!auth.IsAuthUser() ? 'without-login' : '' "  class="main-container  submission-to-lender ">
  <div class="container container-super">
    

    <div class="form-content-box">
      <!-- <h3 class="title">Hello, {{userName}} !</h3> -->
      <mat-label class="labelsuper">Take your next step with Cashel Family Office!</mat-label>
      <p class="sub-para" *ngIf="!auth.IsAuthUser()">
        Already a Cashel Family Office Client?
        <a style="cursor: pointer;" (click)="openDialog('LOGIN TO YOUR ACCOUNT')">Log In</a>
      </p>
    </div>

    <div class="row">
      <a [routerLink]="" (click)="applicationSelection('/superannuation')"  class="col l3 m6 s12 margin-top2 ">
        <div class="start-card">
          <div class="card-icon  ">
            <svg width="39" height="29" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M38.163 14.282C37.3344 13.9719 36.5781 13.4955 35.9407 12.882C34.4842 11.2633 33.2544 9.45412 32.2852 7.5042L36.0518 1.62642C36.2359 1.35395 36.2743 1.00841 36.1545 0.702202C36.0347 0.395993 35.772 0.168258 35.4518 0.0930847C33.5145 -0.163603 31.5437 0.112989 29.7518 0.893085C28.4843 1.44883 27.311 2.19855 26.2741 3.11531C24.2851 2.13776 22.1427 1.51006 19.9407 1.25975C12.3852 0.559751 5.12962 5.42642 4.31851 12.2042L4.16295 12.1264C3.37658 11.7794 2.77193 11.1183 2.49629 10.3042C2.31689 9.73118 2.37701 9.10996 2.66295 8.58197C2.78812 8.36213 2.96802 8.17841 3.18518 8.04864C3.7528 7.705 3.93438 6.96627 3.59073 6.39864C3.24709 5.83101 2.50836 5.64944 1.94073 5.99308C1.37315 6.3306 0.902388 6.80902 0.574066 7.38197C-0.0323224 8.48228 -0.164703 9.78201 0.207399 10.982C0.661374 12.4379 1.69392 13.6432 3.06295 14.3153L4.17407 14.9153C4.35167 17.7426 5.10804 20.5034 6.39629 23.0264C7.28437 24.9308 8.40393 26.7184 9.72962 28.3486C9.94404 28.6201 10.2726 28.7762 10.6185 28.7709H14.6296C14.816 28.7476 14.9795 28.6352 15.0679 28.4694C15.1563 28.3037 15.1586 28.1053 15.0741 27.9375L14.8296 27.0709C14.6831 26.641 14.5607 26.2033 14.463 25.7598C15.4741 25.9375 16.7741 26.1042 17.6518 26.182C18.8057 26.2719 19.9647 26.2719 21.1185 26.182C21.5518 26.9597 21.9963 27.6597 22.3963 28.2375C22.5882 28.522 22.9087 28.6927 23.2518 28.6931H26.7074C26.9367 28.6901 27.151 28.5784 27.2848 28.392C27.4185 28.2057 27.4558 27.9669 27.3852 27.7486C27.1296 26.9264 26.7963 25.8042 26.5963 25.1153C28.0645 24.6479 29.4653 23.9905 30.763 23.1597C30.8815 23.0783 31 22.9771 31.1185 22.8758C31.1777 22.8252 31.237 22.7746 31.2963 22.7264C30.3667 22.4423 29.4664 22.0702 28.6074 21.6153C28.1717 21.3883 28.0026 20.851 28.2296 20.4153C28.4567 19.9796 28.9939 19.8105 29.4296 20.0375C30.542 20.6139 31.7322 21.0256 32.963 21.2598C33.9485 21.4044 34.9462 21.449 35.9407 21.3931C36.3922 21.3747 36.7875 21.0848 36.9407 20.6597L38.863 15.7264C38.9685 15.4423 38.9535 15.1275 38.8213 14.8547C38.6892 14.582 38.4514 14.3751 38.163 14.282ZM14.5963 6.19308C14.4894 6.23125 14.3765 6.25006 14.263 6.24863C13.8126 6.24152 13.4299 5.91734 13.3488 5.47425C13.2678 5.03116 13.5109 4.5925 13.9296 4.42641C16.3042 3.54374 18.8761 3.3323 21.363 3.8153C21.712 3.85588 22.0097 4.0869 22.1356 4.41496C22.2615 4.74303 22.1949 5.11388 21.9627 5.37761C21.7304 5.64133 21.371 5.7543 21.0296 5.67085C18.8779 5.25125 16.6522 5.43192 14.5963 6.19308ZM26.9074 11.3931C26.9074 12.2768 27.6238 12.9931 28.5074 12.9931L28.5185 13.0042C28.9429 13.0013 29.3487 12.8299 29.6467 12.5277C29.9446 12.2256 30.1104 11.8175 30.1074 11.3931C30.1074 10.5094 29.3911 9.79311 28.5074 9.79311C27.6238 9.79311 26.9074 10.5094 26.9074 11.3931Z" fill="white"/>
              </svg>
              
          </div>
          <div class="start-card-title ">
            <mat-label>Join Cashel Super and Pension</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </div>

      </a>


      <div class="col l3 m6 s12 margin-top2">
        
        <a [routerLink]="" (click)="applicationSelection('/managed-account')" class="start-card">
          <div class="card-icon  ">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
              <path d="M25.1418 25.0287H14.7782L13.3165 33.5596L11.8473 25.0287H1.48365L0 33.6689H26.6328L25.1418 25.0287Z" fill="white"/>
              <path d="M25.1854 6.33081H14.8144L13.3308 14.9637H26.669L25.1854 6.33081Z" fill="white"/>
              <path d="M31.8692 15.6764H21.5055L20.022 24.3163H33.3529L31.8692 15.6764Z" fill="white"/>
              <path d="M18.4944 15.6764H8.13078L6.64722 24.3163H19.9781L18.4944 15.6764Z" fill="white"/>
              <path d="M38.5165 25.0287H28.1528L26.6692 33.6689H40.0001L38.5165 25.0287Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0">
              <rect width="40" height="40" fill="white"/>
              </clipPath>
              </defs>
              </svg>
              
          </div>
          <div class="start-card-title ">
            <mat-label>Open Managed Investment Account</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>
      
      <div class="col l3 m6 s12 margin-top2">
        
        <a  [routerLink]="" (click)="applicationSelection('/debtapp')"  class="start-card">
          <div class="card-icon ">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M38.75 10.0001V11.2501C38.75 11.4159 38.6842 11.5749 38.5669 11.6921C38.4497 11.8093 38.2908 11.8751 38.125 11.8751H36.25V12.8126C36.25 13.3304 35.8302 13.7501 35.3125 13.7501H4.6875C4.16977 13.7501 3.75 13.3304 3.75 12.8126V11.8751H1.875C1.70924 11.8751 1.55027 11.8093 1.43306 11.6921C1.31585 11.5749 1.25 11.4159 1.25 11.2501V10.0001C1.25 9.87649 1.28668 9.75563 1.35539 9.65283C1.4241 9.55003 1.52176 9.46992 1.63602 9.42264L19.761 2.54764C19.914 2.48428 20.086 2.48428 20.239 2.54764L38.364 9.42264C38.4782 9.46992 38.5759 9.55003 38.6446 9.65283C38.7133 9.75563 38.75 9.87649 38.75 10.0001ZM36.875 33.7501H3.125C2.08945 33.7501 1.25 34.5896 1.25 35.6251V36.8751C1.25 37.0409 1.31585 37.1999 1.43306 37.3171C1.55027 37.4343 1.70924 37.5001 1.875 37.5001H38.125C38.2908 37.5001 38.4497 37.4343 38.5669 37.3171C38.6842 37.1999 38.75 37.0409 38.75 36.8751V35.6251C38.75 34.5896 37.9105 33.7501 36.875 33.7501ZM7.5 15.0001V30.0001H4.6875C4.16977 30.0001 3.75 30.4199 3.75 30.9376V32.5001H36.25V30.9376C36.25 30.4199 35.8302 30.0001 35.3125 30.0001H32.5V15.0001H27.5V30.0001H22.5V15.0001H17.5V30.0001H12.5V15.0001H7.5Z" fill="white"/>
              </svg>
              
              
          </div>
          <div class="start-card-title ">
            <mat-label>Apply for finance or refinance</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>


      
      <div class="col l3 m6 s12 margin-top2">
        
        <a  [routerLink]="" (click)="applicationSelection('/life-insurance')" class="start-card">
          <div class="card-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M39.9791 21.9375C37.993 11.2891 30.368 4.89062 22.2222 3.89844V2.5C22.2222 1.11719 21.2291 0 19.9999 0C18.7708 0 17.7777 1.11719 17.7777 2.5V3.89844C9.6041 4.89062 2.04855 11.2891 0.0207708 21.9375C-0.132007 22.7266 0.611049 23.6016 1.31938 22.8281C4.93049 18.5312 8.79855 18.7344 12.3333 25.7188C12.7013 26.4609 13.368 26.3906 13.7013 25.7188C15.1041 22.9531 16.8194 20 19.9999 20C24.0624 20 26.1249 25.375 26.2985 25.7188C26.6319 26.3906 27.2985 26.4609 27.6666 25.7188C31.2083 18.7266 35.1041 18.5781 38.6805 22.8281C39.3958 23.6094 40.1319 22.7266 39.9791 21.9375ZM17.7777 23.5703V33.75C17.7777 34.4375 17.2777 35 16.6666 35C16.1249 35 15.7499 34.5859 15.618 34.1641C15.2083 32.8594 13.9444 32.1797 12.7847 32.6406C11.6249 33.1016 11.0208 34.5312 11.4305 35.8281C12.2083 38.3203 14.3194 39.9922 16.6666 39.9922C19.7291 39.9922 22.2222 37.1875 22.2222 33.7422V23.5625C21.5902 22.9453 20.8472 22.5 19.9999 22.5C19.1458 22.5078 18.4444 22.875 17.7777 23.5703Z" fill="white"/>
              </svg>   
          </div>
          <div class="start-card-title">
            <mat-label>Apply for Life and Personal Insurances</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>

      <div class="col l3 m6 s12 margin-top2">
        
        <a [routerLink]="" (click)="applicationSelection('/general-insurance')" class="start-card">
          <div class="card-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.39334 11.06L20 0.453369L30.6067 11.06C32.7044 13.1578 34.133 15.8306 34.7118 18.7403C35.2906 21.65 34.9935 24.666 33.8582 27.4069C32.7229 30.1477 30.8003 32.4904 28.3335 34.1386C25.8668 35.7868 22.9667 36.6666 20 36.6666C17.0333 36.6666 14.1332 35.7868 11.6665 34.1386C9.19974 32.4904 7.27715 30.1477 6.14183 27.4069C5.00651 24.666 4.70945 21.65 5.28821 18.7403C5.86698 15.8306 7.29557 13.1578 9.39334 11.06ZM21.6667 18.3334V10.8334L14.1667 21.6667H18.3333V29.1667L25.8333 18.3334H21.6667Z" fill="white"/>
              </svg>
              
              
              
              
          </div>
          <div class="start-card-title">
            <mat-label>Apply for General Insurance</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>

      <div class="col l3 m6 s12 margin-top2">
        
        <a [routerLink]="" (click)="applicationSelection('/health-insurance')" class="start-card">
          <div class="card-icon">
            <svg width="30" height="37" viewBox="0 0 30 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.305 3.04333L15 0L28.695 3.04333C29.0651 3.12561 29.3961 3.33161 29.6334 3.62734C29.8706 3.92307 29.9999 4.29086 30 4.67V21.315C29.9999 22.9612 29.5933 24.582 28.8165 26.0333C28.0396 27.4847 26.9164 28.7219 25.5467 29.635L15 36.6667L4.45333 29.635C3.08379 28.722 1.96077 27.4852 1.18391 26.0341C0.407059 24.583 0.000393927 22.9626 0 21.3167V4.67C6.5063e-05 4.29086 0.129397 3.92307 0.366649 3.62734C0.603902 3.33161 0.934895 3.12561 1.305 3.04333ZM13.3333 15H8.33333V18.3333H13.3333V23.3333H16.6667V18.3333H21.6667V15H16.6667V10H13.3333V15Z" fill="white"/>
              </svg>              
          </div>
          <div class="start-card-title ">
            <mat-label>Apply for Health Insurance Review</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>
      
      <div class="col l3 m6 s12 margin-top2">
        
        <a [routerLink]="" (click)="applicationSelection('/estate-planning')" class="start-card">
          <div class="card-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M26.6666 6.66671C26.6666 4.81671 28.1499 3.33337 29.9999 3.33337C31.8499 3.33337 33.3333 4.81671 33.3333 6.66671C33.3333 8.51671 31.8499 10 29.9999 10C28.1499 10 26.6666 8.51671 26.6666 6.66671ZM33.3333 35V26.6667H35.1833C36.3166 26.6667 37.1166 25.55 36.7666 24.4667L33.2666 13.95C32.7999 12.5834 31.5333 11.6667 30.0999 11.6667H29.8999C28.4666 11.6667 27.1833 12.5834 26.7333 13.95L25.2999 18.25C27.0999 19.25 28.3333 21.1334 28.3333 23.3334V36.6667H31.6666C32.5833 36.6667 33.3333 35.9167 33.3333 35ZM20.8333 19.1667C22.2166 19.1667 23.3333 18.05 23.3333 16.6667C23.3333 15.2834 22.2166 14.1667 20.8333 14.1667C19.4499 14.1667 18.3333 15.2834 18.3333 16.6667C18.3333 18.05 19.4499 19.1667 20.8333 19.1667ZM9.16659 10C11.0166 10 12.4999 8.51671 12.4999 6.66671C12.4999 4.81671 11.0166 3.33337 9.16659 3.33337C7.31659 3.33337 5.83325 4.81671 5.83325 6.66671C5.83325 8.51671 7.31659 10 9.16659 10ZM12.4999 35V25H13.3333C14.2499 25 14.9999 24.25 14.9999 23.3334V15C14.9999 13.1667 13.4999 11.6667 11.6666 11.6667H6.66659C4.83325 11.6667 3.33325 13.1667 3.33325 15V23.3334C3.33325 24.25 4.08325 25 4.99992 25H5.83325V35C5.83325 35.9167 6.58325 36.6667 7.49992 36.6667H10.8333C11.7499 36.6667 12.4999 35.9167 12.4999 35ZM16.6666 23.3334V28.3334C16.6666 29.25 17.4166 30 18.3333 30V35C18.3333 35.9167 19.0833 36.6667 19.9999 36.6667H21.6666C22.5833 36.6667 23.3333 35.9167 23.3333 35V30C24.2499 30 24.9999 29.25 24.9999 28.3334V23.3334C24.9999 21.9667 23.8666 20.8334 22.4999 20.8334H19.1666C17.7999 20.8334 16.6666 21.9667 16.6666 23.3334Z" fill="white"/>
              </svg>  
          </div>
          <div class="start-card-title">
            <mat-label>Obtain Estate Planning Assistance</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>
      
      <div class="col l3 m6 s12 margin-top2">
        
        <a  [routerLink]="" (click)="applicationSelection('/financial-planning')" class="start-card">
          <div class="card-icon ">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.8334 15C32.5 16.7666 33.3334 18.99 33.3334 21.6666C33.3334 27.4433 27.1667 28.7933 24.1667 36.6666C23.055 35.7083 22.5 34.32 22.5 32.5C22.5 26.6966 30.8334 23.6833 30.8334 15ZM24.1667 8.33329C26.1667 10.3966 27.1667 12.62 27.1667 15C27.1667 23.2516 17.0917 24.4866 19.1667 36.6666C16.3884 34.7333 15 31.955 15 28.3333C15 22.7916 24.1667 18.3333 24.1667 8.33329ZM16.6667 1.66663C18.8884 4.44496 20 6.94496 20 9.16663C20 19.5833 5.83337 22.87 13.3334 36.6666C8.97337 35.7 5.83337 31.6666 5.83337 26.6666C5.83337 15.8333 16.6667 14.1666 16.6667 1.66663Z" fill="white"/>
              </svg>   
              
          </div>
          <div class="start-card-title">
            <mat-label>Obtain Financial Planning and Strategy Advice</mat-label>
          </div>
          <div class="start-card-continue">
            <mat-label>Continue</mat-label>
            <mat-icon class="material-icons-outlined">
              arrow_forward
              </mat-icon>
          </div>
        </a>

      </div>


      
    </div>
     
   
  </div>
</section>
